//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref, computed, getCurrentInstance, onMounted, onBeforeUnmount } from '@vue/composition-api'
import themeConfig from '@themeConfig'
import store from '@/store'
import { useUtils } from '@core/libs/i18n'
import { formatPhoneNumber, formatEmail } from '@core/utils'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import usePhone from '@core/utils/usePhone'
import { sendCodeSMSUser, sendCodeEmailUser } from '@api'
import router from '@/router'

export default {
  setup() {
    const { t } = useUtils()
    const { encrypt } = useCryptoJs()
    const { formatNumber } = usePhone()
    const { logData, currentLogData } = useLogData()
    const vm = getCurrentInstance().proxy

    const form = ref(null)
    const loginData = ref({
      code: '',
      phoneCode: '',
      fullPhone: '',
      type: '',
      exists: '',
      loginRoute: 'LOGIN_PAGE',
      password: null,
      type_selected: '',
      phone_number: '',
      email: '',
    })

    const totalInput = ref(4)
    const completed = ref(false)
    const accessCode = ref('')
    const timeLeft = ref(60)
    let timer = null

    // Función para iniciar el contador regresivo
    const startTimer = () => {
      timer = setInterval(() => {
        if (timeLeft.value > 0) {
          timeLeft.value -= 1
        } else {
          clearInterval(timer)
          timer = null
        }
      }, 1000)
    }

    const onLoginCode = async () => {
      let respSend = null
      let info = null
      let encryptBody = null
      if (logData.value.type_selected === 'PHONE_NUMBER') {
        info = {
          phone_number: logData.value.fullPhone,
        }
        encryptBody = encrypt(info)
        respSend = await sendCodeSMSUser(encryptBody)
      } else {
        info = {
          email: logData.value.code,
        }
        encryptBody = encrypt(info)
        respSend = await sendCodeEmailUser(encryptBody)
      }

      if (respSend.ok) {
        timeLeft.value = 60
        startTimer()
      }
    }

    // Limpiamos el intervalo cuando se destruya el componente para evitar fugas de memoria
    onBeforeUnmount(() => {
      if (timer) {
        clearInterval(timer)
      }
    })

    const onLoginPassword = async () => {
      router.push({ name: 'auth-login' })
    }

    const formatTime = time => time.toString()

    const onAnotherAccount = async () => {
      /* logData.value.type = ''
      logData.value.code = ''
      logData.value.fullPhone = ''
      logData.value.phoneCode = ''
      await updateLogData(logData.value) */
      router.push({ name: 'auth-login-phone-email' })
    }

    const isFormValid = computed(() => {
      if (accessCode.value && accessCode.value.length === totalInput.value) return true

      return false
    })

    const loginSubmit = async () => {
      if (accessCode.value.length === totalInput.value) {
        const body = {
          code: loginData.value.type === 'EMAIL' ? loginData.value.email : loginData.value.fullPhone || loginData.value.phone_number,
          type: loginData.value.type,
          join_game: loginData.value.joinGame,
          match_code: loginData.value.matchCode,
          login_route: 'ACCESS_CODE_PAGE',
          password: accessCode.value,
        }
        const encryptBody = encrypt(body)

        const userAbility = [
          {
            action: 'manage',
            subject: 'all',
          },
        ]
        vm.$ability.update(userAbility)

        // remove team
        store.dispatch('auth/loginUserAction', {
          data: encryptBody,
          redirect: logData.value.redirect,
          facility: logData.value.facility,
          field: logData.value.field,
          date: logData.value.date,
          time: logData.value.time,
          slot: logData.value.slot,
          pay: logData.value.pay,
          reservationCode: logData.value.reservationCode,
          showPay: logData.value.showPay,
          team: logData.value.team,
          chooseTeam: logData.value.chooseTeam,
          payType: logData.value.payType,
        })
        setTimeout(() => {
          accessCode.value = ''
        }, 800)
      }
    }

    const onChangeLogin = () => {
      router.go(-1)
    }

    const onResend = async () => {
      accessCode.value = ''
      let info = null
      let encryptBody = null
      if (loginData.value.type === 'PHONE_NUMBER') {
        info = {
          phone_number: loginData.value.fullPhone,
        }
        encryptBody = encrypt(info)
        await sendCodeSMSUser(encryptBody)
      } else {
        info = {
          email: loginData.value.code,
        }
        encryptBody = encrypt(info)
        await sendCodeEmailUser(encryptBody)
      }
    }

    onMounted(async () => {
      Object.assign(logData.value, currentLogData.value)
      logData.value.loginRoute = 'LOGIN_PAGE'
      loginData.value = logData.value
      startTimer()
    })

    return {
      form,
      loginData,
      isFormValid,
      onAnotherAccount,
      totalInput,
      completed,
      accessCode,
      onLoginPassword,
      formatPhoneNumber,
      formatEmail,
      formatTime,
      timeLeft,
      onLoginCode,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      loginSubmit,
      onChangeLogin,
      onResend,
      formatNumber,

      t,

      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
